module.exports = __webpack_public_path__ + "img/hire3x-round-logo.1af99472.svg";